import React from 'react';
import { X, RotateCcw } from 'lucide-react';

const CoachingCard = ({ message, loading, onDismiss, onRefresh }) => {
  if (loading) {
    return (
      <div className="surface p-5">
        <p className="label">READING COACH</p>
        <div className="mt-4 space-y-2 animate-pulse">
          <div className="h-3 w-3/4 rounded bg-ink-100 dark:bg-ink-900" />
          <div className="h-3 w-1/2 rounded bg-ink-100 dark:bg-ink-900" />
        </div>
      </div>
    );
  }

  if (!message) return null;

  return (
    <div className="surface p-5">
      <div className="flex items-center justify-between gap-3">
        <p className="label">READING COACH</p>
        <div className="flex items-center gap-0.5">
          {onRefresh && (
            <button
              onClick={onRefresh}
              className="p-1.5 text-ink-500 dark:text-ink-400 hover:text-ink-900 dark:hover:text-ink-100 transition-colors"
              aria-label="새 메시지 받기"
              title="새 메시지 받기"
            >
              <RotateCcw size={14} strokeWidth={1.5} />
            </button>
          )}
          <button
            onClick={onDismiss}
            className="p-1.5 text-ink-500 dark:text-ink-400 hover:text-ink-900 dark:hover:text-ink-100 transition-colors"
            aria-label="닫기"
          >
            <X size={14} strokeWidth={1.5} />
          </button>
        </div>
      </div>

      <p className="mt-4 whitespace-pre-wrap text-[15px] leading-relaxed text-ink-800 dark:text-ink-200 font-sans">
        {message}
      </p>
    </div>
  );
};

export default CoachingCard;
